<dp-header [rightActions]="rightActions" [leftActions]="leftActions" (checklistOptionChanged)="onChecklistOptionChanged($event)"></dp-header>

<dp-search [searchAvailableOptions]="searchAvailableOptions" [showSavedSearchButtons]="false" [hidden]="!isSearchVisible()"
    [searchConfig]="searchConfig" (searchInfo)="sendSearch($event)" (clearResults)="clearSearch()" (hide)="hideSearch()"
    (selectedFiltersInitialized)="onSelectedFiltersInitialized($event)" (possibleFiltersInitialized)="onPossibleFiltersInitialized($event)">
</dp-search>